import React from 'react'
import Svg from './Svg'
export const SvgColumns = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" ref={svgRef} {...props}>
    <path d="M4.145 4h3.68v16h-3.68zM10.161 4h3.677v16h-3.677zM16.178 4h3.678v16h-3.678z" />
  </Svg>
))
SvgColumns.isIcon = true
export default SvgColumns
